import { reactive } from 'vue';
import { appConfig } from '@/config';
export const desktopInstall = reactive({ available: false, installed: false, busy: false });
let installEvent = null;
let initialized = false;
const installedKey = 'jc-desktop-installed';
function rememberInstalled() { try { localStorage.setItem(installedKey,'1'); } catch { /* Storage may be unavailable. */ } }
function rememberedInstalled() { try { return localStorage.getItem(installedKey)==='1'; } catch { return false; } }
export function initializeDesktopInstall() {
  if (initialized || appConfig.capacitorApp) return;
  initialized = true;
  const standalone = window.matchMedia('(display-mode: standalone)');
  const update = () => { const running = standalone.matches || navigator.standalone === true; if(running)rememberInstalled();desktopInstall.installed = running || rememberedInstalled(); };
  window.addEventListener('storage', event => { if(event.key===installedKey)update(); });
  update();
  standalone.addEventListener?.('change', update);
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    installEvent = event;
    // A fresh browser install prompt is stronger evidence than a stale installation record.
    if(!standalone.matches && navigator.standalone!==true){try{localStorage.removeItem(installedKey);}catch{} desktopInstall.installed=false;}
    desktopInstall.available = true;
  });
  window.addEventListener('appinstalled', () => {
    installEvent = null;
    desktopInstall.available = false;
    desktopInstall.installed = true;
    rememberInstalled();
  });
}
export async function requestDesktopInstall() {
  if (desktopInstall.busy) return '';
  if (desktopInstall.installed) return 'installed';
  if (!installEvent) return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ? 'ios' : 'manual';
  const event = installEvent;
  installEvent = null;
  desktopInstall.available = false;
  desktopInstall.busy = true;
  try {
    await event.prompt();
    const choice = await event.userChoice;
    return choice.outcome === 'accepted' ? 'accepted' : 'cancelled';
  } catch { return 'manual'; }
  finally { desktopInstall.busy = false; }
}
